import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function AdminSubscriptions() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/admin/subscriptions").then(({ data }) => setSubs(data)).catch(() => {}); }, []);

  return (
    <div className="p-5 sm:p-8">
      <h1 className="font-heading text-3xl text-chessup-text mb-6">Assinaturas</h1>
      <div className="rounded-xl border border-chessup-border bg-chessup-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-chessup-subtext border-b border-chessup-border">
            <th className="p-3">Aluno</th><th className="p-3">Status</th><th className="p-3">Renovação</th><th className="p-3">Cancela no fim</th>
          </tr></thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id} className="border-b border-chessup-border/40 text-chessup-text">
                <td className="p-3">{s.user_name}<div className="text-xs text-chessup-subtext">{s.user_email}</div></td>
                <td className="p-3">{s.status}</td>
                <td className="p-3 text-chessup-subtext">{formatDate(s.current_period_end)}</td>
                <td className="p-3">{s.cancel_at_period_end ? "Sim" : "Não"}</td>
              </tr>
            ))}
            {!subs.length && <tr><td colSpan={4} className="p-8 text-center text-chessup-subtext">Nenhuma assinatura ainda.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
